import React from 'react';
import { Glyphicon, InputGroup, FormControl, Button } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';

const ActivateSuccess = ({ url, players = [], selectedPlayer, setSelectedPlayer, onRefresh }) => {
    return (
        <React.Fragment>
            <h3>Your flow has been published successfully!</h3>
            <CSSTransitionGroup transitionName="thumbs-up" transitionAppear={true} transitionAppearTimeout={500} transitionLeave={false}>
                <Glyphicon glyph="thumbs-up"></Glyphicon>
            </CSSTransitionGroup>
            <p>You can access this version here:</p>
            <FormControl type="text" readOnly value={url} />
            <InputGroup className="activation-select-player">
                <FormControl 
                    componentClass="select" 
                    value={selectedPlayer} 
                    onChange={setSelectedPlayer}
                >
                    {
                        players.map((player) => <option value={player} key={player}>{player}</option>)
                    }
                </FormControl>
                <InputGroup.Button>
                    <Button onClick={onRefresh}><Glyphicon glyph="refresh"></Glyphicon></Button>
                </InputGroup.Button>
            </InputGroup>
        </React.Fragment>
    );
};

export default ActivateSuccess;